import { AuthorityType } from '@/types'

export interface GetAuthorityTagListRequest {
  authorityType: AuthorityType
  isEdit: boolean
}

export function GetAuthorityTagListRequestToJSON(
  value: GetAuthorityTagListRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    is_edit: value.isEdit ?? undefined
  }
}
